const SCORECARD_MARKERS = [
  'TEACHING QUOTIENT',
  'SUBJECT KNOWLEDGE TEST',
  'This is to confirm that',
  'STATEWIDE TEACHER',
  'COMPETENCY TEST',
]

const SCORECARD_WIDTH_PX = 794

export const isScorecardStillLoading = (bodyText: string) => {
  const normalized = bodyText.toLowerCase()
  return normalized.includes('please wait') && normalized.includes('verif')
}

export const hasScorecardContent = (bodyText: string) =>
  SCORECARD_MARKERS.some(marker => bodyText.includes(marker))

export const isScorecardDomReady = () => {
  const bodyText = document.body?.innerText || ''
  const scorecardEl = document.querySelector('.scorecard-document')
  const isReady = document.documentElement.getAttribute('data-scorecard-ready') === 'true'

  return Boolean(
    scorecardEl &&
      isReady &&
      !isScorecardStillLoading(bodyText) &&
      hasScorecardContent(bodyText)
  )
}

export const waitForScorecardDomReady = (timeoutMs = 120000, pollMs = 500) =>
  new Promise<boolean>(resolve => {
    const startedAt = Date.now()

    const check = () => {
      if (isScorecardDomReady()) {
        resolve(true)
        return
      }

      if (Date.now() - startedAt >= timeoutMs) {
        resolve(false)
        return
      }

      window.setTimeout(check, pollMs)
    }

    check()
  })

const resetCloneLayout = (root: HTMLElement) => {
  root.style.transform = 'none'
  root.style.transformOrigin = 'top center'
  root.style.width = `${SCORECARD_WIDTH_PX}px`
  root.style.maxWidth = `${SCORECARD_WIDTH_PX}px`

  root.querySelectorAll<HTMLElement>('.scorecard-page').forEach(page => {
    page.style.width = '100%'
    page.style.minHeight = '297mm'
    page.style.transform = 'none'
    page.style.boxShadow = 'none'
  })
}

export const createScorecardPdfClone = (scorecardEl: HTMLElement) => {
  const clone = scorecardEl.cloneNode(true) as HTMLElement
  resetCloneLayout(clone)

  const container = document.createElement('div')
  container.style.position = 'fixed'
  container.style.left = '-100000px'
  container.style.top = '0'
  container.style.width = `${SCORECARD_WIDTH_PX}px`
  container.style.background = '#fff'
  container.appendChild(clone)
  document.body.appendChild(container)

  return {
    clone,
    cleanup: () => {
      document.body.removeChild(container)
    },
  }
}
